// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import NewsList from "../views/NewList.vue";
import Head from "../components/Header.vue";
import Foot from "../components/Bottom.vue";
import About from "../views/about/About.vue";
import Strategicgoals from "../views/about/Strategicgoals.vue";
import Partner from "../views/about/Partner.vue";
import AboutLayout from "../views/about/AboutLayout.vue"; // 新增
import Factory from "../views/news/factory.vue"; // 新增
import MouthWash from "../views/news/mouthWash.vue"; // 新增
import Ciif from "../views/news/ciif.vue"; // 新增
import Proton from "../views/news/Proton.vue"; // 新增
import Guidelines from "../views/news/Guidelines.vue"; // 新增
import OIF2026 from "../views/news/HaiqiaoConference.vue"; // 新增
import AI from "../views/news/AI.vue"; // 新增
import CBA from "../views/news/CBA.vue"; // 新增
import ProteinSystem from "../views/news/ProteinSystem.vue";
import CIIF2026 from "../views/news/CIIF2026.vue";
const routes = [
  {
    path: "/",
    name: "Home| Healthcode",
    component: Home,
    meta: {
      title: "康码生物 - 全球领先的无细胞蛋白合成技术企业",
      keywords: "康码生物,无细胞蛋白合成,D2P技术,人造血红蛋白,蛋白营养液,生物科技,细胞-free蛋白质,农业蛋白,医疗蛋白",
      description: "康码（上海）生物科技有限公司是全球唯一具备万吨级无细胞合成蛋白产业化能力的企业，专注于D2P无细胞合成蛋白技术的研发与应用。"
    }
  },
  {
    path: "/news",
    name: "News| Healthcode",
    components: { header: Head, default: NewsList, footer: Foot },
  },
  {
    path: "/news/008",
    name: "Factory",
    components: { header: Head, default: Factory, footer: Foot },
    meta: { title: "蛋白质制备再不被卡脖子！揭秘全球唯一百吨级量产工厂" }
  },
  {
    path: "/news/005",
    name: "MouthWash",
    components: { header: Head, default: MouthWash, footer: Foot },
    meta: { title: "全球首款甜蛋白漱口水，甜甜的无糖才能守护好牙牙！" }
  }, {
    path: "/news/006",
    name: "Ciif",
    components: { header: Head, default: Ciif, footer: Foot },
    meta: { title: "'重磅喜讯！康码生物荣获中国工业奥斯卡'——第25届工博会CIIF大奖" }
  }, {
    path: "/news/007",
    name: "Proton",
    components: { header: Head, default: Proton, footer: Foot },
    meta: { title: "无细胞合成通量有望破万！康码联手蛋白质设施突破蛋白'智造'技术" }
  },
   {
    path: "/news/004",
    name: "Guidelines",
    components: { header: Head, default: Guidelines, footer: Foot },
    meta: { title: "无细胞合成通量有望破万！康码联手蛋白质设施突破蛋白'智造'技术" }
  },
   {
    path: "/news/003",
    name: "HaiqiaoConference",
    components: { header: Head, default: OIF2026, footer: Foot },
    meta: { title: "康码生物在2026年上海第一届外商交易展上亮相" }
  },
  {
    path: "/news/002",
    name: "AI",
    components: { header: Head, default: AI, footer: Foot },
    meta: { title: "AI与生物技术融合：康码生物D2P技术成为AI驱动生物医药革命的关键基础设施" }
  },
  {
    path: "/news/001",
    name: "CBA",
    components: { header: Head, default: CBA, footer: Foot },
    meta: { title: "2026 CBA-China Forum，康码生物，D2P无细胞生物创新药开发智造平台，全球领先，盛大发布！" }
  },
  {
    path: "/news/10",
    name: "CIIF2026",
    components: { header: Head, default: CIIF2026, footer: Foot },
    meta: { title: "康码科技斩获 2026 中国工博会 CIIF 生物制造专项奖！" }
  },
  {
    path: "/news/009",
    name: "ProteinSystem",
    components: { header: Head, default: ProteinSystem, footer: Foot },
    meta: { title: "无细胞蛋白质合成，为什么优选真核系统？" }
  },
  {
    path: "/about",
    name: "About| Healthcode",
    components: { header: Head, default: AboutLayout, footer: Foot },
    children: [
      {
        path: "",
        name: "AboutUs",
        component: About,
        meta: { title: "关于我们" }
      },
      {
        path: "partner",
        name: "Partner",
        component: Partner,
        meta: { title: "合作伙伴" }
      },
      {
        path: "strategicgoals",
        name: "Strategicgoals",
        component: Strategicgoals,
        meta: { title: "战略目标" }
      }
    ]
  }
];


// 安全获取基础 URL
let baseUrl = '/';
try {
  baseUrl = import.meta.env?.BASE_URL || '/';
} catch (error) {
  console.warn('无法获取 BASE_URL 环境变量，使用默认值 "/"');
  baseUrl = '/';
}

const router = createRouter({
  history: createWebHistory(baseUrl),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});



export default router;